import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const animatedAccordionYellowBgVars: MotifComponentProps<MotifComponent.ANIMATED_ACCORDION> =
  {
    '--animated-accordion-progress-indicator-color': m('--fg-color'),
  } as const;

export const animatedAccordionWhiteBgVars: MotifComponentProps<MotifComponent.ANIMATED_ACCORDION> =
  {
    '--animated-accordion-progress-indicator-color': m('--fg-color'),
  } as const;

export const animatedAccordionGrayBgVars: MotifComponentProps<MotifComponent.ANIMATED_ACCORDION> = {
  '--animated-accordion-progress-indicator-color': m('--fg-color'),
} as const;

export const animatedAccordionBlackBgVars: MotifComponentProps<MotifComponent.ANIMATED_ACCORDION> =
  {
    '--animated-accordion-progress-indicator-color': m('--primary-v100'),
  } as const;
